import DeleteIcon from '../../atoms/icons/delete';
import KeyDelete from '../../atoms/container/keyDelete';
import VirtualKeyboardContext from '../../../../shared/components/utils/context/virtualKeyboardContext';
import { selectMagicRemoteEnabled } from '../../../../shared/store/slices/magicRemote.slice';
import { useAppSelector } from '../../../../shared/store/hooks';
import { useContext, useState } from 'react';

function DeleteKey({
  index,
  alternateKeyboard = false,
}: {
  index: number[];
  alternateKeyboard?: boolean;
}) {
  const enabled = useAppSelector(selectMagicRemoteEnabled);
  const { listIndex, listFocused, onClick } = useContext(
    VirtualKeyboardContext
  );
  const [hovered, setHovered] = useState(false);
  const focused = !enabled && listFocused && index.includes(listIndex);
  return (
    <KeyDelete
      onClick={() => index.length && onClick(index[0])}
      onPointerEnter={() => setHovered(true)}
      onPointerLeave={() => setHovered(focused)}
      focused={hovered || focused}
      alternateKeyboard={alternateKeyboard}
    >
      <DeleteIcon focused={focused && index.includes(listIndex)} />
    </KeyDelete>
  );
}

export default DeleteKey;
